/**
 * @generated SignedSource<<97bd382457ba27d0681b0ec1b6beae8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedShopByModule_componentModule$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModuleControl_componentModule">;
  readonly " $fragmentType": "HpSharedShopByModule_componentModule";
};
export type HpSharedShopByModule_componentModule$key = {
  readonly " $data"?: HpSharedShopByModule_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModule_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrendingCreatorsVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedShopByModule_componentModule",
  "selections": [
    {
      "condition": "isTrendingCreatorsVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedShopByModuleControl_componentModule"
        }
      ]
    }
  ],
  "type": "ShopByModule",
  "abstractKey": null
};

(node as any).hash = "c4562eb392ba0591fe31a640a924e23b";

export default node;
